import {IAttributes, IAugmentedJQuery, IDirective, IModule, IScope} from "angular";

export class FeltEndretEventTriggerDirektiv {

    static eventer = {feltendret:'FeltEndretEventTriggerDirektiv.feltendret'};

    static registrerDirektiv(angular: IModule) {
        angular
            .directive('feltEndretEventTrigger', FeltEndretEventTriggerDirektiv.escKeyForInjisering());
    }

    static escKeyForInjisering()  {
        return [FeltEndretEventTriggerDirektiv.escKey];
    }

    /** Lar deg registrere en metode som blir kalt når bruker trykker på esc tasten */
    static escKey(): IDirective {
        return {
            restrict: 'A',
            link: ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes) => {
                let målElement = $element;
                switch ($element.prop('tagName').toLowerCase()){
                    case 'md-datepicker':
                        målElement = $element.find('input');
                        break;
                    case 'wk-medlem-select':
                        //felt-endret-event-trigger er allerede lagt til i wk-medlem-select på required-variantene
                        console.warn('felt-endret-event-trigger støtter ikke wk-medlem-select')
                        return;
                    case 'ckeditor':
                        //felt-endret-event-trigger er allerede lagt til i ckeditor
                        console.warn('felt-endret-event-trigger støtter ikke ckeditor')
                        return;
                }
                //console.log("#### FeltEndretEventTriggerDirektiv LINK", $element, målElement)
                målElement.on('blur', function() {
                    //console.log("#### FeltEndretEventTriggerDirektiv blur")
                    $scope.$emit(FeltEndretEventTriggerDirektiv.eventer.feltendret)
                });
            }
        }
    }

}

